import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export function Footer() {
  const { t } = useLanguage();
  return (
    <footer data-testid="site-footer" className="border-t hairline bg-[#0B0A08]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
          <div>
            <div className="font-serif-d text-2xl tracking-[0.18em] text-[#F7F4EE]">
              ARCHWOOD <span className="gold-text">FRANCE</span>
            </div>
            <p className="mt-3 text-xs font-mono-d tracking-[0.2em] uppercase text-[#7A7367]">{t("ft_tag")}</p>
            <p className="mt-6 text-sm text-[#B8B0A2] max-w-xs leading-relaxed">
              78 avenue des Champs-Élysées<br />75008 Paris — France
            </p>
          </div>
          <div className="flex flex-wrap gap-x-14 gap-y-8">
            <div className="flex flex-col gap-3">
              <span className="text-[10px] font-mono-d tracking-[0.3em] uppercase text-[#C5A059]">{t("rea_kicker")}</span>
              <span className="text-sm text-[#B8B0A2]">Château de Veauce</span>
              <span className="text-sm text-[#B8B0A2]">Prieuré Saint-Léonard de Vains</span>
            </div>
            <div className="flex flex-col gap-3">
              <span className="text-[10px] font-mono-d tracking-[0.3em] uppercase text-[#C5A059]">Navigation</span>
              <a href="#savoir-faire" className="text-sm text-[#B8B0A2] hover:text-[#D4AF37] transition-colors">{t("nav_savoir")}</a>
              <a href="#realisations" className="text-sm text-[#B8B0A2] hover:text-[#D4AF37] transition-colors">{t("nav_realisations")}</a>
              <a href="#expression" className="text-sm text-[#B8B0A2] hover:text-[#D4AF37] transition-colors">{t("nav_cta")}</a>
            </div>
            <div className="flex flex-col gap-3">
              <span className="text-[10px] font-mono-d tracking-[0.3em] uppercase text-[#C5A059]">Atelier</span>
              <Link to="/admin" data-testid="footer-admin-link" className="text-sm text-[#B8B0A2] hover:text-[#D4AF37] transition-colors">{t("admin")}</Link>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-[rgba(197,160,89,0.12)] flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="text-xs text-[#7A7367]">{t("ft_rights")}</span>
          <span className="text-[10px] font-mono-d tracking-[0.3em] uppercase text-[#7A7367]">Fait avec passion à Paris</span>
        </div>
      </div>
    </footer>
  );
}
